import { useObserver } from 'mobx-react-lite';
import React from 'react';
import styled from 'styled-components/macro';
import { ProductLabelULProps } from '../types/ProductLabelProps';

const UnstyledProductLabels: React.FC<ProductLabelULProps> = ({
  className,
  labels,
  activeLabel,
  simpleLabels,
  activeSimpleLabel,
}) => {
  return useObserver(() => (
    <ul className={'ww-product-labels ' + className}>
      {simpleLabels
        ? simpleLabels.map((label) => {
            return (
              <li
                className={label === activeSimpleLabel ? ' active' : ''}
                key={'pl-' + label}
              >
                {label}
              </li>
            );
          })
        : labels?.map((label) => {
            return (
              <li
                className={label === activeLabel ? ' active' : ''}
                key={'pl-' + label}
              >
                {label.priceText}
              </li>
            );
          })}
    </ul>
  ));
};

const ProductLabels = styled(UnstyledProductLabels)`
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: ${(props) => (props.responsive ? 'column' : 'row')};
  list-style: none;
  flex-wrap: wrap;
  font-size: ${(props) => (props.asWarning ? '0.85em' : 'unset')};
  align-items: ${(props) => (props.responsive ? 'right' : 'unset')};
  position: ${(props) => (props.responsive ? 'absolute' : 'unset')};
  top: ${(props) => (props.responsive ? '0' : 'unset')};
  right: ${(props) => (props.responsive ? '0.35em' : 'unset')};

  li {
    padding: ${(props) =>
      props.responsive ? '0.125em 0.5em' : '0.25em 0.5em'};
    background-color: ${(props) =>
      props.asWarning ? 'var(--warn-color)' : 'var(--gray-1)'};
    color: ${(props) => (props.asWarning ? 'var(--white)' : 'inherit')};
    border-radius: 0.25em;
    margin-left: 0;
    margin-top: 0;
    margin-right: ${(props) => (props.responsive ? '0' : '0.35em')};
    margin-bottom: 0.35em;
    font-size: 1em;
    font-weight: 600;
    text-align: ${(props) => (props.responsive ? 'right' : 'unset')};
  }

  li.active {
    background-color: var(--secondary-color);
    color: var(--white);
  }

  li:last-child {
    margin-right: 0;
  }

  @media (min-width: 569px) {
    flex-direction: ${(props) => (props.responsive ? 'row' : 'unset')};
    align-items: ${(props) => (props.responsive ? 'flex-end' : 'unset')};
    position: unset;

    .label {
      text-align: ${(props) => (props.responsive ? 'left' : 'unset')};
      margin-right: ${(props) => (props.responsive ? '0.35em' : 'unset')};
    }
  }
`;

export default ProductLabels;
